import { FileText } from 'lucide-react';

/**
 * Sustituye a `ClientContractSection` mientras los contratos digitales no están
 * listos. Se muestra en vez de ocultarse: enseña lo que viene, y evita que el
 * usuario piense que la ficha del cliente está incompleta.
 *
 * Se cambia AQUÍ, en el punto de uso (`ClienteDetalle`), y no dentro de
 * `ClientContractSection`: así no se monta ningún hook de contratos y no se
 * lanzan las peticiones de una función desactivada. Para reactivarlo basta con
 * volver a poner `<ClientContractSection …/>` en `ClienteDetalle.tsx`; el
 * componente y sus hooks siguen intactos.
 */
const ContractsComingSoon = () => (
    <div className="mt-6 bg-white p-6 rounded-lg shadow">
        <div className="border-b pb-2 mb-4">
            <h2 className="text-lg font-bold flex items-center text-gray-500">
                <FileText className="w-5 h-5 text-gray-400" />
                <span className="ml-2">Contratos Digitales</span>
                <span className="ml-3 rounded-full bg-amber-100 px-3 py-0.5 text-xs font-bold text-amber-800">
                    Próximamente
                </span>
            </h2>
            <p className="text-sm text-gray-500 mt-1">
                Gestión de contratos y firmas digitales del cliente
            </p>
        </div>

        <div className="border border-dashed border-gray-200 rounded-lg p-6 text-center bg-gray-50">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-white border border-gray-200 mb-3">
                <FileText className="h-6 w-6 text-gray-400" />
            </div>
            <h3 className="text-base font-semibold text-gray-700 mb-1">
                Los contratos digitales llegarán pronto
            </h3>
            <p className="text-sm text-gray-500 max-w-md mx-auto">
                Podrás generar el contrato del cliente, enviarlo para firma y guardarlo
                firmado, todo desde esta misma ficha.
            </p>
        </div>
    </div>
);

export default ContractsComingSoon;
